/* eslint-disable */
import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const useQuickBook = () => {
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const navigate = useNavigate();

  const updateToken = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/update-token`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getProfitRevenue = useCallback(async () => {
    try {
      return await ajax.get(`quickbook/get-profit-ytd`, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getProfitRevenuePrevYear = useCallback(async (payload) => {
    console.log(payload, 3000);
    try {
      return await ajax.get(`quickbook/get-profit-prev-year`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalProfitRevenue = useCallback(async (payload) => {
    try {
      return await ajax.get(`quickbook/get-total-profit-revenue`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalPastDueInvoices = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-invoices`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getCronQbFieldsByCell = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/set-qb-fields-by-cell`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const pastDueTableByCell = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-table-for-cell`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const pastDueTableByCountry = useCallback(async (payload) => {
    try {
      console.log(payload, 5656);
      return await ajax.post(`quickbook/get-past-due-table-for-country`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalPastDueInvoicesForAllCells = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-invoices-for-all-cells`, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const authUri = useCallback(async (val) => {
    try {
      console.log('useQB');
      return await ajax.get(`auth/authUri`, val);
    } catch (error) {
      return error;
    }
  });

  const callback = useCallback(async (val) => {
    try {
      return await ajax.get(`auth/callback`, val);
    } catch (error) {
      return error;
    }
  });

  const report = useCallback(async (val) => {
    try {
      console.log(val, 555);
      return await ajax.post(`auth/report`, val);
    } catch (error) {
      return error;
    }
  });

  const reportForQuarters = useCallback(async (val) => {
    try {
      return await ajax.post(`auth/report-for-quarters`, val);
    } catch (error) {
      return error;
    }
  });

  // const retriveToken = useCallback(async (startDate, endDate) => {
  //   try {
  //     const val = { startDate: startDate, endDate: endDate };
  //     return await ajax.get(`auth/report`, val);
  //   } catch (error) {
  //     return error;
  //   }
  // });

  return {
    authUri,
    callback,
    report,
    reportForQuarters,
    updateToken,
    getProfitRevenue,
    getProfitRevenuePrevYear,
    getTotalProfitRevenue,
    getTotalPastDueInvoices,
    getCronQbFieldsByCell,
    getTotalPastDueInvoicesForAllCells,
    pastDueTableByCell,
    pastDueTableByCountry,
    //retriveToken,
  };
};

export default useQuickBook;
